import { GenericConfirmationDialog } from '@/components/Analysis/shared/GeneriConfirmationDialog';
import { Button } from '@mui/material';
import { PoiBulkUploadActionTypes, useBulkUploadPoiActions } from '../actions';

export const IncorrectHeadersDialog = () => {
  const { state, dispatch } = useBulkUploadPoiActions();
  const errors = state.errors;
  const isOpen = state.modal === 'invalid_format';

  if (!isOpen) return <></>;

  return (
    <GenericConfirmationDialog
      title="Incorrect “Template headers”"
      description={
        errors?.reason ||
        'The template headers in the file you uploaded are incorrect. Please upload a file with the correct template headers.'
      }
      onClose={() => dispatch({ type: PoiBulkUploadActionTypes.CLOSE_ALL_MODALS })}
      open={isOpen}
    >
      <Button onClick={() => dispatch({ type: PoiBulkUploadActionTypes.CLOSE_ALL_MODALS })}>OK</Button>
    </GenericConfirmationDialog>
  );
};
